import createHTMLMediaHook from './util/createHTMLMediaHook';
var useVideo = createHTMLMediaHook('video');
export default useVideo;